import styled from 'styled-components';
import Dragger from 'antd/lib/upload/Dragger';

export const StyledUploader = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;
export const StyledRequirements = styled('div')`
  .reqs {
    display: flex;
    flex-direction: column;
    padding-top: 15px;
    padding-bottom: 15px;
    gap: 0;
    font-size: 14px;

    div {
      margin: 0;
      display: flex;
      gap: 10px;
      .formats {
        display: flex;
        gap: 5px;
      }
    }

    .req:before {
      content: '• ';
    }
  }
`;
export const StyledNewUploader = styled(Dragger)`
  .ant-upload-text {
    display: flex;
    gap: 5px;
    .gallery-first-text {
      font-size: 14px;
      font-weight: 600;
      color: ${(props) => props.theme.blue};
    }

    .gallery-second-text {
      font-size: 14px;
      color: ${(props) => props.theme.textColor};
      font-weight: 400;
    }
  }
`;

export const StyledCustomImage = styled('div')`
  display: flex;
  padding-top: 30px;
  flex-direction: row;
  font-family: ${(props) => props.theme.fontText};
  .ant-image {
    height: 147px;
    overflow: hidden;
  }

  .custom-upload-list-item-image {
    width: 150px;
    height: 150px;

    .ant-image {
      height: 150px;
      width: 100%;

      .ant-image-img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }

  .overlay-wrap {
    position: relative;

    .ant-form-item {
      margin: 0;

      .ant-radio-inner {
        border-radius: 20px;
      }

      .ant-radio-wrapper {
        span {
          padding-inline-start: 2px;
        }
        .ant-radio-inner {
          padding-inline-start: 8px;
        }
      }
    }

    .overlay {
      display: flex;
      align-items: center;
      position: absolute;
      width: 87px;
      height: 24px;
      border-radius: 12px;
      margin: 3px;
      background-color: ${(props) => props.theme.white};
      z-index: 1;

      .checkbox-thumbnail {
        font-size: 14px;
        padding: 3px;
        border-radius: 12px;
      }
    }
  }

  .custom-upload-list-item-actions {
    padding-top: 8px;
    display: flex;
    justify-content: space-between;
    .action {
      cursor: pointer;
      text-decoration: underline;
      font-weight: 400;
      font-size: 16px;
      font-family: ${(props) => props.theme.fontText};
    }
  }
`;

export const StyledCustomUploadList = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 40px;
  flex-wrap: wrap;

  .ant-radio-group {
    display: flex;
    flex-direction: row;
    gap: 25px;
  }
`;

export const StyledImagePreviews = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  max-width: 200px;
`;
